// extracted by mini-css-extract-plugin
export var carrierIcon = "_tq-0";
export var carrierLogo = "_tq-1";
export var detailsSection = "_tq-2";